var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_25873)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "url(#paint0_linear_1_25873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9993 29.9976C57.9993 14.5336 45.4632 1.99756 29.9993 1.99756C14.5353 1.99756 1.99927 14.5336 1.99927 29.9976C1.99927 45.4615 14.5353 57.9976 29.9993 57.9976C45.4632 57.9976 57.9993 45.4615 57.9993 29.9976Z",
    fill: "url(#paint1_linear_1_25873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 57C15.1005 57 3 44.8822 3 30C3 15.1178 15.1178 3 30 3C44.8822 3 57 15.1178 57 30C57 44.8822 44.8822 57 30 57Z",
    fill: "url(#paint2_linear_1_25873)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1_25873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0787 30.0001C36.0787 33.3612 33.3612 36.0787 30.0001 36.0787C26.6389 36.0787 23.9214 33.3612 23.9214 30.0001C23.9214 26.6389 26.6389 23.9214 30.0001 23.9214C33.3612 23.9214 36.0787 26.6389 36.0787 30.0001Z",
    fill: "url(#paint3_linear_1_25873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9787 30.0001C35.9787 33.306 33.306 35.9787 30.0001 35.9787C26.6941 35.9787 24.0214 33.306 24.0214 30.0001C24.0214 26.6941 26.6941 24.0214 30.0001 24.0214C33.306 24.0214 35.9787 26.6941 35.9787 30.0001Z",
    stroke: "white",
    strokeWidth: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1_25873",
    x: 21.9214,
    y: 21.9214,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25873"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25873",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25873"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_25873",
    x1: 59.2312,
    y1: 59.2312,
    x2: 0.768773,
    y2: 0.768773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03539"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_25873",
    x1: 11.4686,
    y1: 11.4669,
    x2: 48.9689,
    y2: 48.9672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F54141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_25873",
    x1: 50.1489,
    y1: 49.6627,
    x2: 8.82016,
    y2: 10.2788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA2228"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_25873",
    x1: 33.5756,
    y1: 34.3088,
    x2: 26.22,
    y2: 25.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_25873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB1);
export default __webpack_public_path__ + "static/media/b1.90b466cf65f73d646e17e50224835772.svg";
export { ForwardRef as ReactComponent };